import { render } from "./PledgeManagerInfoStatisticsBox.vue?vue&type=template&id=17e1cfe1"
import script from "./PledgeManagerInfoStatisticsBox.vue?vue&type=script&lang=js"
export * from "./PledgeManagerInfoStatisticsBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__